import React from 'react';
import { Routes, Route } from 'react-router-dom';

import YowanPublicLayout from '../app/YowanPublicLayout';
import {
  AdminBlogCreatePage,
  AdminBlogEditPage,
  AdminBlogAuthorEditPage,
  AdminBlogAuthorInvitePage,
  AdminBlogAuthorsListPage,
  AdminBlogListPage,
  AdminFounderCreatePage,
  AdminFounderEditPage,
  AdminFounderListPage,
  AdminNewsCreatePage,
  AdminNewsEditPage,
  AdminNewsListPage,
  AdminNotificationDetailPage,
  AdminNotificationPoliciesListPage,
  AdminNotificationPolicyDetailPage,
  AdminNotificationRecipientDetailPage,
  AdminNotificationRecipientsListPage,
  AdminNotificationsListPage,
  AdminApplicantDetailPage,
  AdminApplicantsListPage,
  AdminClassApplicationDetailPage,
  AdminClassApplicationsListPage,
  AdminSeminarApplicationDetailPage,
  AdminEventCancelPage,
  AdminEventCreatePage,
  AdminEventDetailPage,
  AdminEventEditPage,
  AdminEventReactivatePage,
  AdminEventSeriesDetailPage,
  AdminEventSeriesEditPage,
  AdminEventApplicationsListPage,
  AdminEventApplicationMailPage,
  AdminEventApplicationMessagesPage,
  AdminEventsListPage,
  AdminFacilitiesCreatePage,
  AdminFacilitiesEditPage,
  AdminFacilitiesListPage,
  AdminInstructorsCreatePage,
  AdminInstructorsEditPage,
  AdminInstructorsListPage,
  AdminOrganizersCreatePage,
  AdminOrganizersEditPage,
  AdminOrganizersListPage,
  AdminMembersCreatePage,
  AdminMembersEditPage,
  AdminMembersListPage,
  AdminMemberAccessCreatePage,
  AdminMemberAccessEditPage,
  AdminMemberAccessListPage,
  AdminMailNewPage,
  AdminMailThreadDetailPage,
  AdminMailThreadStatusPage,
  AdminMailThreadsListPage,
  AdminOperatorsEditPage,
  AdminOperatorsListPage,
  AdminOperatorAccessCreatePage,
  AdminOperatorAccessEditPage,
  AdminOperatorAccessListPage,
  AdminPageContentsEditPage,
  AdminPageContentsListPage,
  AdminRoomsEditPage,
  AdminRoomsListPage,
  AdminReviewsCreatePage,
  AdminReviewsEditPage,
  AdminReviewsListPage,
  AdminStagingDomainFallbackPage,
  AdminDashboardPage,
  BlogPage,
  BlogAuthorDashboardPage,
  BlogAuthorPostCreatePage,
  BlogAuthorPostEditPage,
  BlogAuthorPostsPage,
  BlogDetailPage,
  ClassesPage,
  ContactPage,
  EventDetailPage,
  FounderPage,
  HomePage,
  LoginPage,
  MailMagazinePage,
  MyPageSeminarApplicationsPage,
  MyPageTopPage,
  MyPageProfileUpdatePage,
  NotificationUnsubscribePage,
  OnboardingRequestPage,
  PasswordSetupConfirmPage,
  PasswordResetConfirmPage,
  PasswordResetRequestPage,
  ReviewsPage,
  StakeholderDashboardPage,
  StakeholderClassesPage,
  StakeholderClassDetailPage,
  StakeholderClassApplicationsPage,
  StakeholderProfilePage,
  StakeholderSeminarsPage,
  StakeholderSeminarDetailPage,
  StakeholderSeminarApplicationsPage,
  StakeholderSeminarApplicationMessagesPage,
} from '../pages';
import YowanNotFoundPage from '../pages/YowanNotFoundPage';
import LogOut from '../../../Pages/logout';

const yowanRouteManifest = require('./manifest');

const exactPageRegistry = {
  '/': HomePage,
  '/founder': FounderPage,
  '/reviews': ReviewsPage,
  '/blog': BlogPage,
  '/blog-author': BlogAuthorDashboardPage,
  '/blog-author/posts': BlogAuthorPostsPage,
  '/blog-author/posts/new': BlogAuthorPostCreatePage,
  '/blog-author/posts/:postId/edit': BlogAuthorPostEditPage,
  '/login': LoginPage,
  '/password-reset': PasswordResetRequestPage,
  '/password-reset/confirm': PasswordResetConfirmPage,
  '/password-setup/confirm': PasswordSetupConfirmPage,
  '/onboarding': OnboardingRequestPage,
  '/logout': LogOut,
  '/classes': ClassesPage,
  '/seminars': ClassesPage,
  '/classes/:eventId': EventDetailPage,
  '/seminars/:eventId': EventDetailPage,
  '/contact': ContactPage,
  '/mail-magazine': MailMagazinePage,
  '/notifications/unsubscribe': NotificationUnsubscribePage,
  '/mypage': MyPageTopPage,
  '/mypage/seminars': MyPageSeminarApplicationsPage,
  '/mypage/profile': MyPageProfileUpdatePage,
  '/stakeholder': StakeholderDashboardPage,
  '/stakeholder/classes': StakeholderClassesPage,
  '/stakeholder/classes/:classId': StakeholderClassDetailPage,
  '/stakeholder/classes/:classId/applications': StakeholderClassApplicationsPage,
  '/stakeholder/profile': StakeholderProfilePage,
  '/stakeholder/instructor-profile': StakeholderProfilePage,
  '/stakeholder/organizer-profile': StakeholderProfilePage,
  '/stakeholder/seminars': StakeholderSeminarsPage,
  '/stakeholder/seminars/:eventId': StakeholderSeminarDetailPage,
  '/stakeholder/seminars/:eventId/applications': StakeholderSeminarApplicationsPage,
  '/stakeholder/seminars/:eventId/application-messages': StakeholderSeminarApplicationMessagesPage,
  '/admin': AdminDashboardPage,
  '/admin/deploy/staging-domain-fallback': AdminStagingDomainFallbackPage,
  '/admin/content/founder': AdminFounderListPage,
  '/admin/content/founder/new': AdminFounderCreatePage,
  '/admin/content/founder/:cassetteId/edit': AdminFounderEditPage,
  '/admin/content/blog': AdminBlogListPage,
  '/admin/content/blog/new': AdminBlogCreatePage,
  '/admin/content/blog/:blogId/edit': AdminBlogEditPage,
  '/admin/content/blog-authors': AdminBlogAuthorsListPage,
  '/admin/content/blog-authors/new': AdminBlogAuthorInvitePage,
  '/admin/content/blog-authors/:accessId/edit': AdminBlogAuthorEditPage,
  '/admin/content/news': AdminNewsListPage,
  '/admin/content/news/new': AdminNewsCreatePage,
  '/admin/content/news/:newsId/edit': AdminNewsEditPage,
  '/admin/mail': AdminMailThreadsListPage,
  '/admin/mail/new': AdminMailNewPage,
  '/admin/mail/threads/:threadId/status': AdminMailThreadStatusPage,
  '/admin/mail/threads/:threadId': AdminMailThreadDetailPage,
  '/admin/content/page-contents': AdminPageContentsListPage,
  '/admin/content/page-contents/:pageKey/:slotKey/edit': AdminPageContentsEditPage,
  '/admin/notifications': AdminNotificationsListPage,
  '/admin/notifications/policies': AdminNotificationPoliciesListPage,
  '/admin/notifications/policies/:eventKey': AdminNotificationPolicyDetailPage,
  '/admin/notifications/recipients': AdminNotificationRecipientsListPage,
  '/admin/notifications/recipients/:recipientId': AdminNotificationRecipientDetailPage,
  '/admin/notifications/:dispatchId': AdminNotificationDetailPage,
  '/admin/members': AdminMembersListPage,
  '/admin/members/new': AdminMembersCreatePage,
  '/admin/members/:memberId/edit': AdminMembersEditPage,
  '/admin/operators': AdminOperatorsListPage,
  '/admin/operators/:accessId/edit': AdminOperatorsEditPage,
  '/admin/applicants': AdminApplicantsListPage,
  '/admin/applicants/:applicantId': AdminApplicantDetailPage,
  '/admin/events/classes': AdminEventsListPage,
  '/admin/events/seminars': AdminEventsListPage,
  '/admin/events/new': AdminEventCreatePage,
  '/admin/events/series/:seriesId/edit': AdminEventSeriesEditPage,
  '/admin/events/series/:seriesId/application-messages': AdminEventApplicationMessagesPage,
  '/admin/events/series/:seriesId': AdminEventSeriesDetailPage,
  '/admin/events/:eventId/cancel': AdminEventCancelPage,
  '/admin/events/:eventId/reactivate': AdminEventReactivatePage,
  '/admin/events/:eventId/edit': AdminEventEditPage,
  '/admin/events/:eventId': AdminEventDetailPage,
  '/admin/events/classes/:classId/applications': AdminClassApplicationsListPage,
  '/admin/events/classes/applications/:applicationId': AdminClassApplicationDetailPage,
  '/admin/events/seminars/applications/:applicationId': AdminSeminarApplicationDetailPage,
  '/admin/events/:eventId/application-messages': AdminEventApplicationMessagesPage,
  '/admin/events/:eventId/applications': AdminEventApplicationsListPage,
  '/admin/events/:eventId/applications/mail': AdminEventApplicationMailPage,
  '/admin/events/facilities': AdminFacilitiesListPage,
  '/admin/events/facilities/new': AdminFacilitiesCreatePage,
  '/admin/events/facilities/:facilityId/edit': AdminFacilitiesEditPage,
  '/admin/events/rooms': AdminRoomsListPage,
  '/admin/events/rooms/:roomId/edit': AdminRoomsEditPage,
  '/admin/events/instructors': AdminInstructorsListPage,
  '/admin/events/instructors/new': AdminInstructorsCreatePage,
  '/admin/events/instructors/:instructorId/edit': AdminInstructorsEditPage,
  '/admin/events/organizers': AdminOrganizersListPage,
  '/admin/events/organizers/new': AdminOrganizersCreatePage,
  '/admin/events/organizers/:organizerId/edit': AdminOrganizersEditPage,
  '/admin/access/member': AdminMemberAccessListPage,
  '/admin/access/member/new': AdminMemberAccessCreatePage,
  '/admin/access/member/:accessId/edit': AdminMemberAccessEditPage,
  '/admin/access/operator': AdminOperatorAccessListPage,
  '/admin/access/operator/new': AdminOperatorAccessCreatePage,
  '/admin/access/operator/:accessId/edit': AdminOperatorAccessEditPage,
  '/admin/content/reviews': AdminReviewsListPage,
  '/admin/content/reviews/new': AdminReviewsCreatePage,
  '/admin/content/reviews/:reviewId/edit': AdminReviewsEditPage,
};

const getPageComponent = (routePath) => {
  if (routePath.startsWith('/blog/')) {
    return BlogDetailPage;
  }

  return exactPageRegistry[routePath];
};

const getGuardOptions = (routePath) => {
  if (routePath.startsWith('/admin')) {
    return { requiresAuth: true, requiresAdmin: true };
  }

  if (routePath.startsWith('/mypage')) {
    return { requiresAuth: true };
  }

  if (routePath.startsWith('/blog-author')) {
    return { requiresAuth: true, requiresBlogAuthor: true };
  }

  if (routePath.startsWith('/stakeholder')) {
    return { requiresAuth: true };
  }

  return null;
};

const NotFoundPage = () => (
  <YowanPublicLayout>
    <YowanNotFoundPage />
  </YowanPublicLayout>
);

const renderManifestRoutes = () =>
  yowanRouteManifest.map((route) => {
    const PageComponent = getPageComponent(route.path);
    const guardOptions = getGuardOptions(route.path);
    const routeElement = PageComponent ? (
      <YowanPublicLayout>
        <PageComponent guardOptions={guardOptions} />
      </YowanPublicLayout>
    ) : null;

    if (route.path === '/') {
      return <Route key={route.path} index element={routeElement} />;
    }

    return (
      <Route
        key={route.path}
        path={route.path.replace(/^\//, '')}
        element={routeElement}
      />
    );
  });

const YowanRoutes = () => {
  return (
    <Routes>
      {renderManifestRoutes()}
      <Route
        path="blog/:slug"
        element={(
          <YowanPublicLayout>
            <BlogDetailPage />
          </YowanPublicLayout>
        )}
      />
      <Route
        path="yowan/notifications/unsubscribe"
        element={(
          <YowanPublicLayout>
            <NotificationUnsubscribePage />
          </YowanPublicLayout>
        )}
      />
      <Route
        path="admin/content/page-contents"
        element={(
          <YowanPublicLayout>
            <AdminPageContentsListPage guardOptions={{ requiresAuth: true, requiresAdmin: true }} />
          </YowanPublicLayout>
        )}
      />
      <Route
        path="admin/content/page-contents/:pageKey/:slotKey/edit"
        element={(
          <YowanPublicLayout>
            <AdminPageContentsEditPage guardOptions={{ requiresAuth: true, requiresAdmin: true }} />
          </YowanPublicLayout>
        )}
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default YowanRoutes;
